import Area from './Area';
import Merchant from './Merchant';
import MerchantStation from './MerchantStation';

export default class ExploreMerchant {
  public readonly merchant: Merchant;
  public readonly area: Area | null;
  public readonly merchantStations: MerchantStation[];

  constructor(init: ExploreMerchantInitializer) {
    this.area = init.area ? new Area(init.area) : null;
    this.merchant = new Merchant(init.merchant);
    this.merchantStations = init.merchantStations.map(
      merchantStation => new MerchantStation({ ...merchantStation }),
    );
  }
}

export interface ExploreMerchantInitializer {
  merchant: Merchant;
  area: Area | null;
  merchantStations: MerchantStation[];
}
